// components/BreadcrumbsNav.js
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext } from "react";

import { EventContext } from '../../pages/Dashboard';

const BreadcrumbsNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { eventID } = useParams();
  const event = useContext(EventContext); // optional

  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      <Link underline="hover" color="inherit" onClick={() => navigate("/admin")}>
        Dashboard
      </Link>

      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;

        let label = value;

        // Beautify the breadcrumb name
        if (value === "admin") label = "Events";
        else if (value === eventID && event?.eventName)
          label = event.eventName;
        else if (value === "guests") label = "Guests";
        else label = value.charAt(0).toUpperCase() + value.slice(1);

        return isLast ? (
          <Typography key={to} color="text.primary" variant="body1" sx={{ color: 'text.primary', fontWeight: 600 }}>
            {label}
          </Typography>
        ) : (
          <Link
            key={to}
            underline="hover"
            color="inherit"
            onClick={() => navigate(to)}
          >
            {label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbsNav;
